import { render, staticRenderFns } from "./StepperRelatorio.vue?vue&type=template&id=71d2e94f&scoped=true"
import script from "./StepperRelatorio.vue?vue&type=script&lang=js"
export * from "./StepperRelatorio.vue?vue&type=script&lang=js"
import style0 from "./StepperRelatorio.vue?vue&type=style&index=0&id=71d2e94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2e94f",
  null
  
)

export default component.exports